const STATES: any = [
  { state: 'AL' , name: 'Alabama'},
  { state: 'AK' , name: 'Alaska'},
  { state: 'AZ' , name: 'Arizona'},
  { state: 'AR' , name: 'Arkansas'},
  { state: 'AS' , name: 'American Samoa'},
  { state: 'CA' , name: 'California'},
  { state: 'CO' , name: 'Colorado'},
  { state: 'CT' , name: 'Connecticut'},
  { state: 'DE' , name: 'Delaware'},
  { state: 'FL' , name: 'Florida'},
  { state: 'GA' , name: 'Georgia'},
  { state: 'GU' , name: 'Guam'},
  { state: 'HI' , name: 'Hawaii'},
  { state: 'ID' , name: 'Idaho'},
  { state: 'IL' , name: 'Illinois'},
  { state: 'IN' , name: 'Indiana'},
  { state: 'IA' , name: 'Iowa'},
  { state: 'KS' , name: 'Kansas'},
  { state: 'KY' , name: 'Kentucky'},
  { state: 'LA' , name: 'Louisiana'},
  { state: 'ME' , name: 'Maine'    },
  { state: 'MD' , name: 'Maryland'    },
  { state: 'MA' , name: 'Massachusetts'    },
  { state: 'MI' , name: 'Michigan'    },
  { state: 'MN' , name: 'Minnesota'    },
  { state: 'MS' , name: 'Mississippi'},
  { state: 'MO' , name: 'Missouri'},
  { state: 'MT' , name: 'Montana'},
  { state: 'NE' , name: 'Nebraska'},
  { state: 'NV' , name: 'Nevada'},
  { state: 'NH' , name: 'New Hampshire'},
  { state: 'NJ' , name: 'New Jersey'},
  { state: 'NM' , name: 'New Mexico'},
  { state: 'NY' , name: 'New York'},
  { state: 'NC' , name: 'North Carolina'},
  { state: 'ND' , name: 'North Dakota'},
  { state: 'OH' , name: 'Ohio'},
  { state: 'OK' , name: 'Oklahoma'},
  { state: 'OR' , name: 'Oregon'},
  { state: 'PA' , name: 'Pennsylvania'},
  { state: 'PR' , name: 'Puerto Rico'  },
  { state: 'RI' , name: 'Rhode Island'   },
  { state: 'SC' , name: 'South Carolina'   },
  { state: 'SD' , name: 'South Dakota'   },
  { state: 'TN' , name: 'Tennessee '   },
  { state: 'TX' , name: 'Texas'   },
  { state: 'UT' , name: 'Utah'   },
  { state: 'VT' , name: 'Vermont'   },
  { state: 'VA' , name: 'Virginia'   },
  { state: 'VI' , name: 'U.S. Virgin Islands'   },
  { state: 'WA' , name: 'Washington'   },
  { state: 'DC' , name: 'Washington D.C.'   },
  { state: 'WV' , name: 'West Virginia'   },
  { state: 'WI' , name: 'Wisconsin'   },
  { state: 'WY' , name: 'Wyoming' },
  { state: 'AB' , name: 'Alberta'   },
  { state: 'BC' , name: 'British Columbia'   },
  { state: 'MB' , name: 'Manitoba'   },
  { state: 'NB' , name: 'New Brunswick'   },
  { state: 'NL' , name: 'Newfoundland and Labrador'   },
  { state: 'NT' , name: 'Northwest Territories'   },
  { state: 'NS' , name: 'Nova Scotia'   },
  { state: 'NU' , name: 'Nunavut'   },
  { state: 'ON' , name: 'Ontario'   },
  { state: 'PE' , name: 'Prince Edward Island'   },
  { state: 'QC' , name: 'Quebec'   },
  { state: 'SK' , name: 'Saskatchewan'   },
  { state: 'YT' , name: 'Yukon' } ]; 
  
  export default STATES;